import client from "./axiosConfig";

//Get all GRNs
export const getGRNs=(params)=>{
  const config={
    url:"/procurement/grns/",
    method:"GET",
    params,
  };

  return client(config);
};

//Get GRN by ID
export const getGRNById = (id) => {
  const config = {
    url: `/procurement/grns/${id}/`,
    method: "GET",
  };

  return client(config);
};

// Create GRN
export const createGRN = (data) => {
  const config = {
    url: "/procurement/grns/",
    method: "POST",
    data,
  };

  return client(config);
};

// Update GRN
export const updateGRN = (id, data) => {
  const config = {
    url: `/procurement/grns/${id}/`,
    method: "PATCH",
    data,
  };

  return client(config);
};

// Delete GRN
export const deleteGRN = (id) => {
  const config = {
    url: `/procurement/grns/${id}/`,
    method: "DELETE",
  };

  return client(config);
};

// Get received GRN items (paginated)
export const getGRNItems = (grnId, params) => {
  const config = {
    url: `/procurement/grns/${grnId}/items/`,
    method: "GET",
    params,
  };

  return client(config);
};

// Create a received GRN item
export const createGRNItem = (grnId, data) => {
  const config = {
    url: `/procurement/grns/${grnId}/items/`,
    method: "POST",
    data,
  };

  return client(config);
};

// Update a received GRN item
export const updateGRNItem = (grnId, itemId, data) => {
  const config = {
    url: `/procurement/grns/${grnId}/items/${itemId}/`,
    method: "PATCH",
    data,
  };

  return client(config);
};

// Delete a received GRN item
export const deleteGRNItem = (grnId, itemId) => {
  const config = {
    url: `/procurement/grns/${grnId}/items/${itemId}/`,
    method: "DELETE",
  };

  return client(config);
};
